import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';
import { ButtonProps } from 'antd/es/button';
import useSubmitEvidenceModal from './SubmitEvidenceModal';

/** 上传证据; */
const SubmitEvidence = (
  props: Omit<ButtonProps, 'onClick'> & {
    internalStoreId: string;
    returnSn: string;
    externalStoreId: string;
    externalTradeId: string;
    platform?: General.PlatformUpperCase;
  },
) => {
  const { internalStoreId, returnSn, externalStoreId, externalTradeId, platform, ...restProps } =
    props;
  const { t } = useTranslate();
  const [open, modalInstance] = useSubmitEvidenceModal(
    internalStoreId,
    returnSn,
    externalStoreId,
    externalTradeId,
  );

  return (
    <>
      <Button size="small" {...restProps} onClick={() => open()} disabled={platform !== 'SHOPEE'}>
        {t('trade.上传证据')}
      </Button>
      {modalInstance}
    </>
  );
};

export default SubmitEvidence;
